var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",staticStyle:{"padding":"20px"}},_vm._l((30),function(y){return _c('v-row',{key:y},_vm._l((12),function(x){return _c('v-col',{key:x,attrs:{"sm":"1"}},[_c('img',{staticClass:"fa-spin",staticStyle:{"height":"30px","float":"left"},attrs:{"src":require("../assets/logo.svg"),"alt":""}}),_c('h5',[_vm._v("404")])])}),1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }